export const attrs = {

    Purpose: "Purpose",
    Residue: "Residue",

    BiomassLevel: "Biomass level",
    NLeafAnalysis: "Previous crop N leaf analysis",
    NCropGroup: "Crop group for N requirements",

    GrassManagement: "Management",
    GrassCuts: "Cuts",

    GrowingSeasonLength: "Growing season length",

    ProtectionStatus: "Protection"

} as const
